<template>
  <v-list class="py-0" v-if="['super_admin', 'education_manager', 'manager'].includes(role.type)">
    <!-- <Dashboard /> -->
    <!-- <v-divider inset /> -->
    <Sales v-if="['super_admin'].includes(role.type)" />
    <v-divider inset />
    <Study />
    <v-divider inset />
    <Department />
    <v-divider inset />
    <!-- <Settings v-if="['super_admin'].includes(role.type)" /> -->
    <v-divider inset />
    <Advanced />
  </v-list>
</template>
<script>
import Department from '@/components/basic/menu/Department'
import Sales from '@/components/basic/menu/Sales'
import Study from '@/components/basic/menu/Study'
import Settings from '@/components/basic/menu/Settings'
import Dashboard from '@/components/basic/menu/Dashboard'
import Advanced from '@/components/basic/menu/Advanced.vue'
import { mapState } from 'vuex'
export default {
  components: {
    Department,
    Sales,
    Settings,
    Study,
    Advanced,
    Dashboard
  },
  computed: {
    ...mapState('auth', ['profile', 'role'])
  }
}
</script>
